import {
	type OrderFeeUpdateDto,
	patchOrdersOrderIdFeeFeeId,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { getOrderDetailQueryKey } from "Order/Api/Query/useOrderDetailQuery";
import { getOrderFeeQueryKey } from "Order/Modules/Payment/Api/Query/useOrderFeeQuery";
import { getOrderPaymentDetailQueryKey } from "Order/Modules/Payment/Api/Query/useOrderPaymentDetailQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const paymentMutationsResource = Resources.base.payment.mutation;

export const useUpdateOrderFeeMutation = (orderId: number, feeId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: OrderFeeUpdateDto) =>
			patchOrdersOrderIdFeeFeeId(data, orderId, feeId),
		),
		onError: (error) => {
			console.error(
				`${t(paymentMutationsResource.updateOrderFeeError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(t(paymentMutationsResource.updateOrderFeeSuccess));
			queryClient.invalidateQueries({
				queryKey: getOrderFeeQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderPaymentDetailQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderDetailQueryKey(orderId),
			});
		},
	});
};
